import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { ReactComponent as Op36Icon } from '../../assets/images/common/icons/sidebarMenu/Op36.svg'
import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'
import UserMenuTooltip from './UserMenuTooltip'

import classes from './LandingHeader.module.scss'

const LandingHeader = () => {
  const user = useSelector(state => state.user.current_user)

  return (
    <header className={classNames('d-none d-lg-flex', classes.landingHeader)}>
      <a href='https://operation36.golf' target='_blank'>
        <Op36Icon className={classes.op36Icon}/>
      </a>

      {user && (
        <>
          <div className={classNames(classes.avatarWrapper, 'small-round-image-wrapper ml-auto')} data-for='userTooltip' data-tip>
            <img
              className='round-image'
              src={user.avatar ? user.avatar.file_url : AvatarPlaceholder}
              alt={`${user.first_name} ${user.last_name}`}
            />
          </div>
          <UserMenuTooltip id='userTooltip' user={user} />
        </>
      )}
    </header>
  )
}

export default LandingHeader
